import NoteIcon from '@mui/icons-material/Note';
import { Button } from '@mui/material';

const ATTIO_WORKSPACE = 'scalar-valuation';

export type AttioNotesObject = 'company' | 'person';

export const getAttioNotesUrl = (object: AttioNotesObject, recordId: string) =>
  `https://app.attio.com/${ATTIO_WORKSPACE}/${object}/${recordId}/notes`;

interface AttioNotesButtonProps {
  recordId?: string;
  object: AttioNotesObject;
  hasNotes: boolean;
}

const AttioNotesButton = ({ recordId, object, hasNotes }: AttioNotesButtonProps) => (
  <Button
    variant="contained"
    disabled={!hasNotes || !recordId}
    size="small"
    sx={{
      width: '100px',
      gap: '0.5rem',
    }}
    onClick={() => {
      if (recordId) {
        window.open(getAttioNotesUrl(object, recordId), '_blank');
      }
    }}
  >
    <NoteIcon />
    Notes
  </Button>
);

export default AttioNotesButton;
